import { useMemo } from "react";
import { LabeledSelect, SelectOption } from "@itwin/itwinui-react";
import { IDataCenter } from "../../interfaces/IDataCenter";

export interface DataCenterSelectProps {
  label: string;
  value: string | undefined;
  onChange: (value: string | undefined) => void;
  dataCenters: IDataCenter[];
  isLoading: boolean;
  style?: React.CSSProperties;
}

export const DataCenterSelect = (props: DataCenterSelectProps) => {
  const { label, value, onChange, dataCenters, isLoading, style } = props;

  const options: SelectOption<string>[] = useMemo(() => {
    const allOptions: SelectOption<string>[] = dataCenters.map((dc) => ({
      label: `${dc.locationName} (${dc.id})`,
      value: dc.id,
    }));

    // Add an empty option at the beginning
    allOptions.unshift({ label: "None", value: "" });

    return allOptions;
  }, [dataCenters]);

  const handleChange = (selectedValue: string) => {
    onChange(selectedValue === "" ? undefined : selectedValue);
  };

  return (
    <LabeledSelect
      label={label}
      options={options}
      value={value ?? ""}
      onChange={handleChange}
      placeholder={isLoading ? "Loading..." : "Select data center..."}
      disabled={isLoading}
      style={style}
    />
  );
};
